module.exports = __webpack_public_path__ + "static/img/011.d82c48ff.png";